module.exports = __webpack_public_path__ + "img/icon5.813358cd.png";